import gsap from "gsap";

document.addEventListener('DOMContentLoaded', () => {
    const optimizeTexture = document.querySelector('#optimizeTexture');
    const textureQualityGroup = document.querySelector('#textureQualityGroup');
    const fileUpload = document.getElementById('fileUpload');
    const uploadContainer = document.getElementById('uploadContainer');
    const optimizerNotify = document.getElementById('optimizerNotify');
    const fileDetails = document.getElementById('fileDetails');
    const errorMessage = document.getElementById('errorMessage');
    const fileNameElement = document.getElementById('fileName');
    const fileSizeElement = document.getElementById('fileSize');
    const removeFileButton = document.getElementById('removeFile');
    const optimizerFormFooter = document.getElementById('optimizerFormFooter');
    const submitOptimizerForm = document.getElementById('submitOptimizerForm');

    if (optimizeTexture && textureQualityGroup) {
        optimizeTexture.addEventListener('change', () => toggleTextureQualityGroup(optimizeTexture, textureQualityGroup));
        toggleTextureQualityGroup(optimizeTexture, textureQualityGroup);
    }

    if (fileUpload && removeFileButton) {
        fileUpload.addEventListener('change', handleFileChange);
        removeFileButton.addEventListener('click', resetFileUpload);
    }

    if (submitOptimizerForm) {
        submitOptimizerForm.addEventListener('click', () => {
            const file = fileUpload.files[0];
            if (file) {
                const formData = new FormData();
                formData.append('file-upload', file);

                fetch('/path/to/optimize-file.php', {
                    method: 'POST',
                    body: formData
                })
                .then(response => response.text())
                .then(data => {
                    document.getElementById('optimizerFormFooter').insertAdjacentHTML('beforeend', data);
                })
                .catch(error => {
                    console.error('Errore nella richiesta di ottimizzazione:', error);
                });
            }
        });
    }

    function toggleTextureQualityGroup(optimizeTexture, textureQualityGroup) {
        if (textureQualityGroup) {
            const isVisible = optimizeTexture.checked;
            gsap.to(textureQualityGroup, {
                duration: isVisible ? 0.5 : 0.25,
                height: isVisible ? 'auto' : 0,
                opacity: isVisible ? 1 : 0,
                display: isVisible ? 'block' : 'none',
            });
        }
    }

    async function handleFileChange(event) {
        const file = event.target.files[0];

        if (file) {
            const { valid, errorMessage: error } = await validateFile(file);
            if (valid) {
                updateUIForValidFile(file);
            } else {
                updateUIForInvalidFile(file, error);
            }
        }
    }

    function resetFileUpload() {
        if (uploadContainer && optimizerNotify) {
            fileUpload.value = '';
            gsap.to(uploadContainer, { duration: 0.25, opacity: 1, display: 'block' });
            gsap.to(optimizerNotify, { duration: 0.25, opacity: 0, display: 'none' });
        }
    }

    function updateUIForValidFile(file) {
        if (uploadContainer && optimizerNotify && fileDetails && errorMessage) {
            optimizerNotify.classList.remove('error');
            optimizerNotify.classList.add('success');

            gsap.to(uploadContainer, { duration: 0.25, opacity: 0, display: 'none' });
            gsap.to(optimizerNotify, { duration: 0.25, opacity: 1, display: 'block' });
            gsap.to(fileDetails, { duration: 0.25, opacity: 1, display: 'grid' });
            gsap.to(errorMessage, { duration: 0.25, opacity: 0, display: 'none' });
            
            fileNameElement.textContent = file.name;
            fileSizeElement.textContent = `${(file.size / (1024 * 1024)).toFixed(2)}MB`;
        }
    }

    function updateUIForInvalidFile(file, message) {
        if (uploadContainer && optimizerNotify && fileDetails && errorMessage) {
            optimizerNotify.classList.remove('success');
            optimizerNotify.classList.add('error');
            
            gsap.to(uploadContainer, { duration: 0.25, opacity: 0, display: 'none' });
            gsap.to(optimizerNotify, { duration: 0.25, opacity: 1, display: 'block' });
            gsap.to(fileDetails, { duration: 0.25, opacity: 1, display: 'grid' });
            gsap.to(errorMessage, { duration: 0.25, opacity: 1, display: 'grid' });

            fileNameElement.textContent = file.name;
            fileSizeElement.textContent = `${(file.size / (1024 * 1024)).toFixed(2)}MB`;
        }
    }

    function validateFile(file) {
        const isValid = file.size <= 50 * 1024 * 1024 && (file.name.endsWith('.glb') || file.name.endsWith('.fbx'));
        return Promise.resolve({
            valid: isValid
        });
    }
});